import React, { useState, useEffect } from "react";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import { getUoms } from "../../../../services/setup/inventory/itemSetupService";
const SearchUom = ({ onSelectUom }) => {
  const { reload } = useGlobalData();
  const [uoms, setUoms] = useState([]);
  useEffect(() => {
    getUomsData();
  }, [reload]);

  async function getUomsData() {
    const response = await getUoms();
    const { data } = response.data;
    setUoms(data.uoms);
  }

  return (
    <CustomDataTableSearch
      data={uoms}
      onRefreshData={() => {
        getUomsData();
      }}
      onSelectedData={(rowData, originalEvent) => {
        onSelectUom(rowData);
      }}
      columns={[
        {
          field: "select",
          body: (rowData) => (
            <React.Fragment>
              <button
                type="button"
                className="btn btn-label-success btn-sm btn-pill btn-bold"
                onClick={() => onSelectUom(rowData)}
              >
                Select <i className="fas fa-angle-double-right"></i>
              </button>
            </React.Fragment>
          ),
        },
        {
          header: "Unit of Measurement Code",
          field: "uom",
          body: null,
          sortable: true,
        },
        {
          header: "Unit of Measurement Name",
          field: "uomName",
          body: null,
          sortable: true,
        },
      ]}
    />
  );
};

export default SearchUom;
